module.exports = __webpack_public_path__ + "static/media/service_system_7.e578f7e9.png";